import React, { useState } from 'react';
import Heading from '../../../../components/Heading';
import ToggleArrow from '../ToggleArrow';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Styles
import styles from './Accordion.styl';

const cx = classNames.bind(styles);

const Accordion = ({ title, children, className }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <div className={cx('Accordion', className)}>
      <div className={cx('Accordion__item')} onClick={handleOpen}>
        <Heading tagName="div" level={3}>
          {title}
        </Heading>
        <ToggleArrow isOpen={open} />
      </div>
      {open && children}
    </div>
  );
};

export default Accordion;

Accordion.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};
